import style from "./TableHead.module.scss";

export function TableHead() {
    return (
        <div className={style.head}>
            <div>Промокод</div>
            <div>Тип</div>
            <div>Дія промокоду</div>
            <div>Використано</div>
            <div></div>
        </div>
    )
}